<template>
  <ListboxItem v-bind="props" :is-active="isActive" ref="optionRef" @click="selectOption" />
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, inject, ref, watch } from 'vue';

import { ListboxItemProps } from '../listbox/listbox-item-props.interface';
import ListboxItem from '../listbox/listbox-item.vue';
import { autocompleteInjectionKey } from './autocomplete.token';

const props = defineProps<{ value: unknown } & ListboxItemProps>();
const optionRef = ref<InstanceType<typeof ListboxItem> | null>(null);
const autocomplete = inject(autocompleteInjectionKey);
const currentInstance = getCurrentInstance();
const isActive = computed(() => autocomplete?.activeOptionKey.value === currentInstance?.vnode?.key);

function selectOption() {
  autocomplete?.selectOption(props.value);
}

watch(isActive, (value) => {
  if (value) {
    optionRef.value?.listboxItemRef?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
});

watch(
  () => autocomplete?.selectedOptionKey.value,
  (key) => {
    if (currentInstance?.vnode?.key === key) {
      selectOption();
    }
  },
);
</script>
